import loadable from '@loadable/component'

const ProductViewModal = loadable(() => import('./internal'))

export default ProductViewModal
